module.exports = __webpack_public_path__ + "img/111.84416456.jpg";